import bag1 from "../assets/bag11.jpg";
import bag11 from "../assets/bag111.jpg";
import bag12 from "../assets/bag112.jpg";
import bag13 from "../assets/bag113.jpg";
import bag14 from "../assets/bag114.jpg";
import bag2 from "../assets/bag12.jpg";
import bag21 from "../assets/bag121.jpg";
import bag22 from "../assets/bag122.jpg";
import bag23 from "../assets/bag123.jpg";
import bag24 from "../assets/bag124.jpg";
import bag3 from "../assets/bag13.jpg";
import bag31 from "../assets/bag131.jpg";
import bag32 from "../assets/bag132.jpg";
import bag33 from "../assets/bag133.jpg";
import bag34 from "../assets/bag134.jpg";
import bag4 from "../assets/bag14.jpg";
import bag41 from "../assets/bag141.jpg";
import bag42 from "../assets/bag142.jpg";
import bag43 from "../assets/bag143.jpg";
import bag44 from "../assets/bag144.jpg";
import bag5 from "../assets/bag15.jpg";
import bag51 from "../assets/bag151.jpg";
import bag52 from "../assets/bag152.jpg";
import bag53 from "../assets/bag153.jpg";
import bag54 from "../assets/bag154.jpg";
import bag6 from "../assets/bag16.jpg";
import bag61 from "../assets/bag161.jpg";
import bag62 from "../assets/bag162.jpg";
import bag63 from "../assets/bag163.jpg";
import bag64 from "../assets/bag164.jpg";
import bag7 from "../assets/bag17.jpg";
import bag71 from "../assets/bag171.jpg";
import bag72 from "../assets/bag172.jpg";
import bag73 from "../assets/bag173.jpg";
import bag74 from "../assets/bag174.jpg";
import bag8 from "../assets/bag18.jpg";
import bag81 from "../assets/bag181.jpg";
import bag82 from "../assets/bag182.jpg";
import bag83 from "../assets/bag183.jpg";
import bag84 from "../assets/bag184.jpg";
import bag9 from "../assets/bag19.jpg";
import bag91 from "../assets/bag191.jpg";
import bag92 from "../assets/bag192.jpg";
import bag93 from "../assets/bag193.jpg";
import bag94 from "../assets/bag194.jpg";
import Canvasbag from "../assets/CanvasShoppingBag.jpg";
import Canvasbag1 from "../assets/CanvasShoppingBag1.jpg";
import Canvasbag2 from "../assets/CanvasShoppingBag2.jpg";
import Canvasbag3 from "../assets/CanvasShoppingBag3.jpg";
import Cottonbag from "../assets/CottonCarryBag.jpg";
import Cottonbag1 from "../assets/CottonCarryBag1.jpg";
import Cottonbag2 from "../assets/CottonCarryBag2.jpg";
import CottonMixbag from "../assets/CottonMixFabricCarryBags.jpg";
import CottonMixbag1 from "../assets/CottonMixFabricCarryBags1.jpg";
import CottonMixbag2 from "../assets/CottonMixFabricCarryBags2.jpg";
import CottonShopbag from "../assets/CottonShoppingBag.jpg";
import CottonShopbag1 from "../assets/CottonShoppingBag1.jpg";
import CottonShopbag2 from "../assets/CottonShoppingBag2.jpg";
import JuteBag from "../assets/JuteBag.jpg";
import JuteBag1 from "../assets/JuteBag1.jpg";
import JuteBag2 from "../assets/JuteBag2.jpg";
import JuteBag3 from "../assets/JuteBag3.jpg";
import JuteBag4 from "../assets/JuteBag4.jpg";
import JuteBags from "../assets/JuteBags.jpg";
import JuteBags1 from "../assets/JuteBags1.jpg";
import JuteBags2 from "../assets/JuteBags2.jpg";
import PromotionalBag from "../assets/PromotionalBag.jpg";
import PromotionalBag1 from "../assets/PromotionalBag1.jpg";
import PromotionalBag2 from "../assets/PromotionalBag2.jpg";
import JutePromotionalBag from "../assets/JuteBagPromotional.jpg";
import JutePromotionalBag1 from "../assets/JuteBagPromotional1.jpg";
import JutePromotionalBag2 from "../assets/JuteBagPromotional2.jpg";
import bag10 from "../assets/bag20.jpg";
const products = [
  {
    id: 1,    
    name: "Botanical Print Eco-Friendly Shopping Bag",
    price: 799,
    images: [bag1,bag11, bag12, bag13,bag14],
    category: "clothbags",
    description: "Verdant Whispers Watercolor Leaves Cotton Canvas Tote Bag | Botanical Print Eco-Friendly Reusable Shopping Bag",
  },
  {
    id: 2,
    name: "Cute Christmas Canvas Bag",
    price: 999,
    images: [bag2,bag21, bag22, bag23,bag24],
    category: "clothbags",
    description: "Festive Sloth Tote Bag with Santa Hat | Cute Christmas Canvas Bag | Holiday Shopping & Reusable Gift | Winter Animal Lover Present",
  },
  {
    id: 3,
    name: "Fern Leaf Tote Bag",
    price: 1199,
    images: [bag3,bag31, bag32, bag33,bag34], 
    category: "canvasbags", 
    description: "Fern Leaf Tote Bag | Abstract Sage Green Botanical Purse",
  },
  {
    id: 4,
    name: "Botanical Plants Canvas Tote Bag",
    price: 1199,
    images: [bag4, bag41, bag42, bag43,bag44],
    category: "canvasbags", 
    description: "Botanical Plants Canvas Tote Bag, Plant Bag, Botanical Print, Shopper, Shoulder Bag, fair trade, Botanical Bag, Gift for her, Shopper Bag",
  },
  {
    id: 5,
    name: "Houseplants Cutting Tote Bag",
    price: 1199,
    images: [bag5, bag51, bag52, bag53,bag54],
    category: "canvasbags",
    description: "Houseplants Cutting Tote Bags - Watercolour, Pressed Flowers, Water Colour, House Plants, Watercolor Illustration Totes",
  },
  {
    id: 6,
    name: "Botanical Garden Tote bag",
    price: 1199,
    images: [bag6, bag61, bag62, bag63,bag64],
    category: "canvasbags",
    description: "Botanical Garden Tote – Watercolor Leaves & Wildflowers, Cotton Canvas",
  },
  {
    id: 7,
    name: "Harvest Harmony Cotton Canvas Tote Bag",
    price: 1199,
    images: [bag7, bag71, bag72, bag73,bag74],
    category: "canvasbags",
    description: "Harvest Harmony Cotton Canvas Tote Bag | Farmer Illustration Eco-Friendly Reusable Grocery Bag | Rural Life Nature Mid-Century Modern",
  },
  {
    id: 8,
    name: "Cotton Canvas Tote Bag",
    price: 1199,
    images: [bag8, bag81, bag82, bag83,bag84],
    category: "canvasbags",
    description: "Cotton Canvas Tote Bag with Farmer Illustration, Reusable Shopping Bag, Hopeful Growth Design, Inspirational Quote, Eco-Friendly Gift",
  },
  {
    id: 9,
    name: "Fern Tote Bag",
    price: 1199,
    images: [bag9, bag91, bag92, bag93,bag94],
    category: "canvasbags",
    description: "Fern Tote Bag, Plant Lover Gift, Botanical Bag, Gardener Tote, Nature Tote bag, PNW Gift, Out Door Lover Gift, Forest ,National park Tote",
  },
  {
    id: 10,
    name: "Canvas Shopping Bag",
    price: 15,
    images: [Canvasbag, Canvasbag1, Canvasbag2, Canvasbag3],
    category: "canvasbags",
    description: "Canvas Shopping Bag",
  },
  {
    id: 11,
    name: "Cotton Carry Bag",
    price: 20,
    images: [Cottonbag, Cottonbag1, Cottonbag2],
     category: "clothbags",
    description: "Cotton Carry Bag/ loop handel cotton carry bags / printed shopping bag",
  },
  {
    id: 12,
    name: "Cotton Mix Fabric Carry Bags",
    price: 20,
    images: [CottonMixbag, CottonMixbag1, CottonMixbag2],
    category: "clothbags",
    description: "Cotton Mix Fabric Carry Bags",
  },
  {
    id: 13,
    name: "Cotton Shopping Bag",
    price: 20,
    images: [CottonShopbag, CottonShopbag1, CottonShopbag2],
     category: "clothbags",
    description: "Cotton Shopping Bag/ Biodegradable and environmentally friendly",
  },
   {
    id: 14,
    name: "Natural Jute Bag with Gusset long Handle",
    price: 95,
    images: [JuteBag, JuteBag1, JuteBag2,JuteBag3,JuteBag4],
     category: "jutebag",
    description: "A Natural Jute Bag with Gusset and Lamination is a versatile and eco-friendly bag made from natural jute fibers, enhanced with a laminated interior for added protection and durability.",
  },
   {
    id: 15,
    name: "Coloured Jute Bag with Gusset",
    price: 55,
    images: [JuteBags, JuteBags1, JuteBags2],
    category: "jutebag",
    description: "A coloured jute bag is a type of bag made from jute fibers that has been dyed or treated to achieve a specific color.",
  },
     {
    id: 16,
    name: "Printed Jute Shopping Bag",
    price: 65,
    images: [PromotionalBag, PromotionalBag1, PromotionalBag2],
    category: "promotionbags",    
    description: "White Canvas Promotional Bags, Capacity: 2kg.",
  },
  {
    id: 17,
    name: "Canvas Promotional Bags",
    price: 60,
    images: [JutePromotionalBag, JutePromotionalBag1, JutePromotionalBag2],
    category: "promotionbags",
   description: "Carry your essentials in style with our eco-friendly Printed Jute Shopping Bag.",
  },

]

export default products;